<template>
  <div class="app-wrapper">
    <!--begin::Header-->
    <nav class="app-header navbar navbar-expand bg-body">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Start Navbar Links-->
        <ul class="navbar-nav">
          <li class="nav-item">
            <a
              class="nav-link"
              data-lte-toggle="sidebar"
              href="#"
              role="button"
            >
              <i class="bi bi-list"></i>
            </a>
          </li>
          <!-- <li class="nav-item d-none d-md-block">
            <a href="#" class="nav-link">Home</a>
          </li>
          <li class="nav-item d-none d-md-block">
            <a href="#" class="nav-link">Contact</a>
          </li> -->
        </ul>
        <!--end::Start Navbar Links-->
        <!--begin::End Navbar Links-->
        <ul class="navbar-nav ms-auto">
          <!--begin::Navbar Search-->
          <!-- <li class="nav-item">
            <a
              class="nav-link"
              data-widget="navbar-search"
              href="#"
              role="button"
            >
              <i class="bi bi-search"></i>
            </a>
          </li> -->
          <!--end::Navbar Search-->
          <!--begin::Messages Dropdown Menu-->
          <li class="nav-item dropdown">
            <!-- <a class="nav-link" data-bs-toggle="dropdown" href="#">
              <i class="bi bi-chat-text"></i>
              <span class="navbar-badge badge text-bg-danger">3</span>
            </a> -->
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end">
              <a href="#" class="dropdown-item">
                <!--begin::Message-->
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <img
                      src="/assets/img/user1-128x128.jpg"
                      alt="User Avatar"
                      class="img-size-50 rounded-circle me-3"
                    />
                  </div>
                  <div class="flex-grow-1">
                    <h3 class="dropdown-item-title">
                      Brad Diesel
                      <span class="float-end fs-7 text-danger"
                        ><i class="bi bi-star-fill"></i
                      ></span>
                    </h3>
                    <p class="fs-7">Call me whenever you can...</p>
                    <p class="fs-7 text-secondary">
                      <i class="bi bi-clock-fill me-1"></i> 4 Hours Ago
                    </p>
                  </div>
                </div>
                <!--end::Message-->
              </a>
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item">
                <!--begin::Message-->
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <img
                      src="/assets/img/user8-128x128.jpg"
                      alt="User Avatar"
                      class="img-size-50 rounded-circle me-3"
                    />
                  </div>
                  <div class="flex-grow-1">
                    <h3 class="dropdown-item-title">
                      John Pierce
                      <span class="float-end fs-7 text-secondary">
                        <i class="bi bi-star-fill"></i>
                      </span>
                    </h3>
                    <p class="fs-7">I got your message bro</p>
                    <p class="fs-7 text-secondary">
                      <i class="bi bi-clock-fill me-1"></i> 4 Hours Ago
                    </p>
                  </div>
                </div>
                <!--end::Message-->
              </a>
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item">
                <!--begin::Message-->
                <div class="d-flex">
                  <div class="flex-shrink-0">
                    <img
                      src="/assets/img/user3-128x128.jpg"
                      alt="User Avatar"
                      class="img-size-50 rounded-circle me-3"
                    />
                  </div>
                  <div class="flex-grow-1">
                    <h3 class="dropdown-item-title">
                      Nora Silvester
                      <span class="float-end fs-7 text-warning">
                        <i class="bi bi-star-fill"></i>
                      </span>
                    </h3>
                    <p class="fs-7">The subject goes here</p>
                    <p class="fs-7 text-secondary">
                      <i class="bi bi-clock-fill me-1"></i> 4 Hours Ago
                    </p>
                  </div>
                </div>
                <!--end::Message-->
              </a>
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item dropdown-footer"
                >See All Messages</a
              >
            </div>
          </li>
          <!--end::Messages Dropdown Menu-->
          <!--begin::Notifications Dropdown Menu-->
          <li class="nav-item dropdown">
            <!-- <a class="nav-link" data-bs-toggle="dropdown" href="#">
              <i class="bi bi-bell-fill"></i>
              <span class="navbar-badge badge text-bg-warning">15</span>
            </a> -->
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end">
              <span class="dropdown-item dropdown-header"
                >15 Notifications</span
              >
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item">
                <i class="bi bi-envelope me-2"></i> 4 new messages
                <span class="float-end text-secondary fs-7">3 mins</span>
              </a>
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item">
                <i class="bi bi-people-fill me-2"></i> 8 friend requests
                <span class="float-end text-secondary fs-7">12 hours</span>
              </a>
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item">
                <i class="bi bi-file-earmark-fill me-2"></i> 3 new reports
                <span class="float-end text-secondary fs-7">2 days</span>
              </a>
              <div class="dropdown-divider"></div>
              <a href="#" class="dropdown-item dropdown-footer">
                See All Notifications
              </a>
            </div>
          </li>
          <!--end::Notifications Dropdown Menu-->
          <!--begin::Theme Toggle-->
          <li class="nav-item">
            <button
              type="button"
              class="nav-link theme-toggle"
              :class="{ 'theme-toggle--dark': isDarkMode }"
              :aria-label="isDarkMode ? 'تفعيل الوضع الفاتح' : 'تفعيل الوضع الداكن'"
              :title="isDarkMode ? 'الوضع الفاتح' : 'الوضع الداكن'"
              :aria-pressed="isDarkMode"
              @click="toggleTheme"
            >
              <i :class="isDarkMode ? 'bi bi-sun-fill' : 'bi bi-moon-stars-fill'"></i>
            </button>
          </li>
          <!--end::Theme Toggle-->
          <!--begin::Fullscreen Toggle-->
          <li class="nav-item">
            <a class="nav-link" href="#" data-lte-toggle="fullscreen">
              <i data-lte-icon="maximize" class="bi bi-arrows-fullscreen"></i>
              <i
                data-lte-icon="minimize"
                class="bi bi-fullscreen-exit"
                style="display: none"
              ></i>
            </a>
          </li>
          <!--end::Fullscreen Toggle-->
          <!--begin::User Menu Dropdown-->
          <li class="nav-item dropdown user-menu">
            <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
              <img
                v-if="GET_USER_DATA.avatar"
                :src="$store.getters.MEDIA_URL + GET_USER_DATA.avatar"
                class="user-image rounded-circle shadow"
                alt="User Image"
                style="width:32px;height:32px;object-fit:cover;"
              />
              <i v-else class="bi bi-person-circle fs-4 align-middle me-1"></i>
              <span class="d-none d-md-inline">{{ GET_USER_DATA.userName }}</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-end">
              <!--begin::User Image-->
              <li class="user-header text-bg-primary text-center py-3">
                <img
                  v-if="GET_USER_DATA.avatar"
                  :src="$store.getters.MEDIA_URL + GET_USER_DATA.avatar"
                  class="rounded-circle shadow mb-2"
                  alt="User Image"
                  style="width:80px;height:80px;object-fit:cover;"
                />
                <div v-else class="mb-2">
                  <i class="bi bi-person-circle" style="font-size:64px;opacity:.85;"></i>
                </div>
                <p class="mb-0 fw-bold">{{ GET_USER_DATA.userName }}</p>
              </li>
              <!--end::User Image-->
              <!--begin::Menu Body-->
              <li class="p-2">
                <button class="btn btn-outline-primary btn-sm w-100 mb-1" @click.prevent="openProfileModal">
                  <i class="bi bi-person-gear me-1"></i> تعديل الملف الشخصي
                </button>
                <button class="btn btn-outline-secondary btn-sm w-100" @click.prevent="openPasswordModal">
                  <i class="bi bi-key me-1"></i> تغيير كلمة المرور
                </button>
              </li>
              <!--end::Menu Body-->
              <!--begin::Menu Footer-->
              <li class="user-footer text-center">
                <a href="#" class="btn btn-default btn-flat" @click.prevent="logout()">
                  تسجيل الخروج <i class="bi bi-box-arrow-left mx-1"></i>
                </a>
              </li>
              <!--end::Menu Footer-->
            </ul>
          </li>
          <!--end::User Menu Dropdown-->
        </ul>
        <!--end::End Navbar Links-->
      </div>
      <!--end::Container-->
    </nav>
    <!--end::Header-->
    <!--begin::Sidebar-->
    <aside class="app-sidebar bg-body-secondary shadow" data-bs-theme="dark">
      <!--begin::Sidebar Brand-->
      <div class="sidebar-brand">
        <!--begin::Brand Link-->
        <router-link to="/" class="brand-link">
          <!--begin::Brand Image-->
          <img
            src="/assets/img/brand-mark.svg"
            alt="شعار أحمد المحيسني العقارية"
            class="brand-image"
          />
          <!--end::Brand Image-->
          <!--begin::Brand Text-->
          <span class="brand-copy">
            <span class="brand-text">أحمد المحيسني العقارية</span>
            <small>خبرة عقارية، رؤية حديثة</small>
          </span>
          <!--end::Brand Text-->
        </router-link>
        <!--end::Brand Link-->
      </div>
      <!--end::Sidebar Brand-->
      <!--begin::Sidebar Wrapper-->
      <div class="sidebar-wrapper">
        <nav class="mt-2">
          <!--begin::Sidebar Menu-->
          <ul
            class="nav sidebar-menu flex-column"
            data-lte-toggle="treeview"
            role="menu"
            data-accordion="false"
          >
            <li class="nav-item">
              <router-link to="/" class="nav-link auto-close">
                <i class="nav-icon bi bi-speedometer"></i>
                <p>الرئيسية</p>
              </router-link>
            </li>
            <li v-if="checkAccess('charts_read')" class="nav-item">
              <router-link to="/stats" class="nav-link auto-close">
                <i class="nav-icon bi bi-graph-up-arrow"></i>
                <p>لوحة التحكم</p>
              </router-link>
            </li>
            <li v-if="checkAccess('admin_notifications_read')" class="nav-item">
              <router-link to="/notifications" class="nav-link auto-close">
                <i class="nav-icon fa-solid fa-bell"></i>
                <p>التنبيهات <span v-if="unseenNotifications > 0" class="badge text-bg-danger" id="unseenNotifications">{{ unseenNotifications }}</span></p>
              </router-link>
            </li>
            
            <li 
              v-if="
                checkAccess('users_read') || checkAccess('users_attempts_read') || checkAccess('register_prizes_read') ||
                checkAccess('packages_subscriptions_read') || checkAccess('restore_accounts_read') || checkAccess('account_details_read')
              " 
              class="nav-item">
              <a href="#" class="nav-link">
                <i class="nav-icon fa-solid fa-users"></i>
                <p>
                  العملاء
                  <i class="nav-arrow bi bi-chevron-right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li v-if="checkAccess('users_read')" class="nav-item">
                  <router-link to="/clients" class="nav-link auto-close">
                    <i class="nav-icon bi bi-person-lines-fill"></i>
                    <p>سجل العملاء</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('account_details_read')" class="nav-item">
                  <router-link to="/accountDetails" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-user-tag"></i>
                    <p>انواع حسابات العملاء</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('users_attempts_read')" class="nav-item">
                  <router-link to="/registrationAttempts" class="nav-link auto-close">
                    <i class="nav-icon bi bi-person-dash"></i>
                    <p>عملاء حاولوا التسجيل</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('register_prizes_read')" class="nav-item">
                  <router-link to="/registerPrizes" class="nav-link auto-close">
                    <i class="nav-icon bi bi-gift"></i>
                    <p>جائزة تسجيل عميل</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('packages_subscriptions_read')" class="nav-item">
                  <router-link to="/packagesSubscriptions" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-id-card"></i>
                    <p>اشتراكات الباقات الصيانة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('restore_accounts_read')" class="nav-item">  
                  <router-link to="/restoreAccounts" class="nav-link auto-close">
                    <i class="nav-icon bi bi-trash"></i>
                    <p> الحسابات المحذوفة</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li v-if="checkAccess('providers_read') || checkAccess('providers_transactions_read')" class="nav-item">
              <a href="#" class="nav-link">
                <i class="nav-icon fa-solid fa-helmet-safety"></i>
                <p>
                  المزودين
                  <i class="nav-arrow bi bi-chevron-right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li v-if="checkAccess('providers_read')" class="nav-item">
                  <router-link to="/providers" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-person-digging"></i>
                    <p>مزودين الخدمة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('providers_transactions_read')" class="nav-item">
                  <router-link to="/pTransactions" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-money-bill-transfer"></i>
                    <p>المعاملات المالية</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li 
              v-if="
                checkAccess('projects_read') || checkAccess('projects_create') || checkAccess('property_containers_read') || checkAccess('property_read') || checkAccess('property_map_read') || checkAccess('overdue_rentals_read') ||
                checkAccess('property_document_read') || checkAccess('management_request_read') || checkAccess('reservation_read') ||
                checkAccess('prop_reservation_read') || checkAccess('finance_requests_read') || checkAccess('property_requests_read') || 
                checkAccess('ad_license_requests_read') || checkAccess('property_banner_requests_read') || checkAccess('prices_offers_read') ||
                checkAccess('contracts_read') || checkAccess('contracts_create') || checkAccess('contract_templates_manage')
              " 
              class="nav-item">
              <a href="#" class="nav-link">
                <i class="nav-icon fa-solid fa-vihara"></i>
                <p>
                  العقارات
                  <i class="nav-arrow bi bi-chevron-right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li v-if="checkAccess('projects_read') || checkAccess('projects_create')" class="nav-item">
                  <router-link :to="checkAccess('projects_read') ? '/projects' : '/projects/create'" class="nav-link auto-close">
                    <i class="nav-icon bi bi-buildings"></i>
                    <p>المشاريع العقارية</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_containers_read')" class="nav-item">
                  <router-link to="/propertyContainers" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-city"></i>
                    <p>عقارات متعددة الوحدات</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_read')" class="nav-item">
                  <router-link to="/properties" class="nav-link auto-close">
                    <i class="nav-icon bi bi-houses"></i>
                    <p>العقارات (RE)</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_read')" class="nav-item">
                  <router-link to="/companyProperty" class="nav-link auto-close">
                    <i class="nav-icon bi bi-building"></i>
                    <p>عقارات الشركة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_map_read')" class="nav-item">
                  <router-link to="/properties/map" class="nav-link auto-close">
                    <i class="nav-icon bi bi-geo-alt-fill"></i>
                    <p>خريطة العقارات</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_banner_requests_read')" class="nav-item">
                  <router-link to="/propertyMarketingMaterials" class="nav-link auto-close">
                    <i class="nav-icon bi bi-megaphone-fill"></i>
                    <p>طلبات المواد التسويقية</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('overdue_rentals_read')" class="nav-item">
                  <router-link to="/overdueRentals" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-triangle-exclamation"></i>
                    <p>الإيجارات المتأخرة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_document_read')" class="nav-item">
                  <router-link to="/propertyDocs" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-building-shield"></i>
                    <p>توثيق العقارات (D)</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('management_request_read')" class="nav-item">
                  <router-link to="/managementReqs" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-building-flag"></i>
                    <p>إدارة الاملاك (M)</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('reservation_read')" class="nav-item">
                  <router-link to="/reservations" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-calendar-check"></i>
                    <p>طلبات المعاينة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('prop_reservation_read')" class="nav-item">
                  <router-link to="/booking" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-building-lock"></i>
                    <p>حجز العقارات (RR)</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('finance_requests_read')" class="nav-item">
                  <router-link to="/financeRequests" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-comments-dollar"></i>
                    <p>طلبات التمويل (F)</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_requests_read')" class="nav-item">
                  <router-link to="/proRequest" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-building-circle-exclamation"></i>
                    <p>طلب عقار (P)</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('ad_license_requests_read')" class="nav-item">
                  <router-link to="/adLicenseReq" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-bullhorn"></i>
                    <p>طلبات اصدار ترخيص اعلاني</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_read')" class="nav-item">
                  <router-link to="/properties/archive" class="nav-link auto-close">
                    <i class="nav-icon bi bi-archive"></i>
                    <p>أرشيف العقارات</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('prices_offers_read')" class="nav-item">
                  <router-link to="/pricesOffers" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-file-invoice-dollar"></i>
                    <p>عروض الأسعار</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('contracts_read') || checkAccess('contracts_create') || checkAccess('contract_templates_manage')" class="nav-item">
                  <router-link :to="checkAccess('contracts_read') ? '/contracts' : checkAccess('contracts_create') ? '/contracts/create' : '/contracts/templates'" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-file-signature"></i>
                    <p>منصة العقود العقارية</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li 
              v-if="
                checkAccess('maintenance_orders_read') || checkAccess('maintenance_orders_global') || checkAccess('photos_orders_read')
              " 
              class="nav-item"
            >
              <a href="#" class="nav-link">
                <i class="nav-icon fa-solid fa-wrench"></i>
                <p>
                  الصيانة
                  <i class="nav-arrow bi bi-chevron-right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li v-if="checkAccess('maintenance_orders_read')" class="nav-item">
                  <router-link to="/orders" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-screwdriver-wrench"></i>
                    <p>طلبات الصيانة (MO)</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('maintenance_orders_global')" class="nav-item">
                  <router-link to="/general-maintenance" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-building-shield"></i>
                    <p>طلبات الصيانة العامة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('maintenance_orders_read')" class="nav-item">
                  <router-link to="/orders/delayed" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-clock-rotate-left"></i>
                    <p>طلبات الصيانة المتأخرة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('photos_orders_read')" class="nav-item">
                  <router-link to="/photos" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-camera-retro"></i>
                    <p>طلبات التصوير (PO)</p>
                  </router-link>
                </li>
              </ul>
            </li>
            
            <li v-if="checkAccess('exchange_read')" class="nav-item">
              <router-link to="/exchanges" class="nav-link auto-close">
                <i class="nav-icon fa-solid fa-arrow-right-arrow-left"></i>
                <p>التقبيل</p>
              </router-link>
            </li>
            
            <li v-if="checkAccess('lawyer_requests_read')" class="nav-header">الخدمات</li>
            <li v-if="checkAccess('lawyer_requests_read')" class="nav-item">
              <router-link to="/lawyerReq" class="nav-link auto-close">
                <i class="nav-icon fa-solid fa-gavel"></i>
                <p>اطلب محاميك (LA)</p>
              </router-link>
            </li>

            <li 
              v-if="
                checkAccess('complains_read') || checkAccess('contact_us_read')
              " 
              class="nav-item"
            >
              <a href="#" class="nav-link">
                <i class="nav-icon fa-solid fa-tty"></i>
                <p>
                  التواصل
                  <i class="nav-arrow bi bi-chevron-right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li v-if="checkAccess('complains_read')" class="nav-item">
                  <router-link to="/complains" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-face-angry"></i>
                    <p>الشكاوى</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('contact_us_read')" class="nav-item">
                  <router-link to="/contactUs" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-headset"></i>
                    <p>اتصل بنا</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('contact_us_read')" class="nav-item">
                  <router-link to="/chatContactUs" class="nav-link auto-close">
                    <i class="nav-icon fa-regular fa-comments"></i>
                    <p>محادثات خدمة العملاء</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li 
              v-if="
                checkAccess('coupons_read') || checkAccess('photo_packages_read') || checkAccess('maintenance_packages_read')
              " 
              class="nav-item"
            >
              <a href="#" class="nav-link">
                <i class="nav-icon fa-solid fa-sack-dollar"></i>
                <p>
                  الخصومات والباقات
                  <i class="nav-arrow bi bi-chevron-right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li v-if="checkAccess('coupons_read')" class="nav-item">
                  <router-link to="/coupons" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-percent"></i>
                    <p>كوبونات الخصم</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('photo_packages_read')" class="nav-item">
                  <router-link to="/photoPackages" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-camera"></i>
                    <p>باقات التصوير</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('maintenance_packages_read')" class="nav-item">
                  <router-link to="/mPackages" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-box-open"></i>
                    <p>باقات الصيانة</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li 
              v-if="
                checkAccess('banners_read') || checkAccess('forums_read') || checkAccess('shareWin_read') || 
                checkAccess('latestNews_read') || checkAccess('questions_read') || checkAccess('providers_questions_read') 
              " 
              class="nav-item"
            >
              <a href="#" class="nav-link">
                <i class="nav-icon fa-regular fa-newspaper"></i>
                <p>
                  منشورات ومقالات
                  <i class="nav-arrow bi bi-chevron-right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li v-if="checkAccess('forums_read')" class="nav-item">
                  <router-link to="/forums" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-newspaper"></i>
                    <p>المدونة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('latestNews_read')" class="nav-item">
                  <router-link to="/latestNews" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-newspaper"></i>
                    <p>نشرات وأخبار العقارية</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('banners_read')" class="nav-item">
                  <router-link to="/banners" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-panorama"></i>
                    <p>الصور الإعلانية</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('shareWin_read')" class="nav-item">
                  <router-link to="/shareWin" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-share-nodes"></i>
                    <p>شارك واربح</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('questions_read')" class="nav-item">
                  <router-link to="/questions" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-clipboard-question"></i>
                    <p>الاسئلة الشائعة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('providers_questions_read')" class="nav-item">
                  <router-link to="/pQuestions" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-question"></i>
                    <p>الاسئلة الشائعة للمزود</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li v-if="checkAccess('payments_read') || checkAccess('marketing_notifications_read')" class="nav-header">الإدارة</li>
            <li v-if="checkAccess('payments_read')" class="nav-item">
              <router-link to="/payments" class="nav-link auto-close">
                <i class="nav-icon fa-solid fa-file-invoice-dollar"></i>
                <p>المدفوعات</p>
              </router-link>
            </li>
            <li v-if="checkAccess('marketing_notifications_read')" class="nav-item">
              <router-link to="/mNotifications" class="nav-link auto-close">
                <i class="nav-icon fa-solid fa-bell-concierge"></i>
                <p>الإشعارات التسويقية</p>
              </router-link>
            </li>
            

            <li v-if="checkAccess('agents_read') || checkAccess('property_types_read') || checkAccess('property_features_read') || checkAccess('property_container_types_read')" class="nav-item">
              <a href="#" class="nav-link">
                <i class="nav-icon fa-solid fa-house-chimney-window"></i>
                <p>
                  إعدادات العقارات
                  <i class="nav-arrow bi bi-chevron-right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li v-if="checkAccess('agents_read')" class="nav-item">
                  <router-link to="/agentview" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-building-user"></i>
                    <p>وكلاء العقارية</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_types_read')" class="nav-item">
                  <router-link to="/typeview" class="nav-link auto-close">
                    <i class="nav-icon bi bi-building-fill-gear"></i>
                    <p>أنواع العقار</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_features_read')" class="nav-item">
                  <router-link to="/featuresview" class="nav-link auto-close">
                    <i class="nav-icon bi bi-buildings"></i>
                    <p>مميزات العقار</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_container_types_read')" class="nav-item">
                  <router-link to="/propertyContainerTypes" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-building-un"></i>
                    <p>انواع عقارات متعددة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('property_banner_sizes_read')" class="nav-item">
                  <router-link to="/propertyBannerSizes" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-rectangle-ad"></i>
                    <p>مقاسات اللوحة الإعلانية</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li v-if="checkAccess('exchange_assets_read') || checkAccess('exchange_businesses_read') || checkAccess('exchange_fronts_read') || checkAccess('exchange_reasons_read') || checkAccess('exchange_strengths_read') || checkAccess('exchange_weaknesses_read')" class="nav-item">
              <a href="#" class="nav-link">
                <i class="nav-icon fa-solid fa-house-chimney-window"></i>
                <p>
                  إعدادات التقبيل
                  <i class="nav-arrow bi bi-chevron-right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li v-if="checkAccess('exchange_assets_read')" class="nav-item">
                  <router-link to="/exchangeAssets" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-chair"></i>
                    <p>حالة الاصول الثابتة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('exchange_businesses_read')" class="nav-item">
                  <router-link to="/exchangeBusinesses" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-people-roof"></i>
                    <p>الانشطة التجارية</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('exchange_fronts_read')" class="nav-item">
                  <router-link to="/exchangeFronts" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-signs-post"></i>
                    <p>الوجهات</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('exchange_reasons_read')" class="nav-item">
                  <router-link to="/exchangeReasons" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-clipboard-question"></i>
                    <p>اسباب التقبيل</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('exchange_strengths_read')" class="nav-item">
                  <router-link to="/exchangeStrengths" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-dumbbell"></i>
                    <p>نقاط القوة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('exchange_weaknesses_read')" class="nav-item">
                  <router-link to="/exchangeWeaknesses" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-skull-crossbones"></i>
                    <p>نقاط الضعف</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li 
              v-if="
                checkAccess('regions_read') || checkAccess('cities_read') || checkAccess('neighborhoods_read') || checkAccess('ages_read') || checkAccess('banks_read') || 
                checkAccess('admins_read') || checkAccess('groups_read') || checkAccess('settings_read') || checkAccess('users_buffers_read') || checkAccess('admin_histories_read') || checkAccess('error_logs_read') || 
                checkAccess('complain_reasons_read') || checkAccess('maintenance_issues_read') || checkAccess('marketing_material_options_read')
              " 
              class="nav-item"
              >
              <a href="#" class="nav-link">
                <i class="nav-icon bi bi-box-seam-fill"></i>
                <p>
                  الإعدادات العامة
                  <i class="nav-arrow bi bi-chevron-right"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <li v-if="checkAccess('maintenance_issues_read')" class="nav-item">
                  <router-link to="/mIssues" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-paint-roller"></i>
                    <p>خدمات الصيانة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('regions_read')" class="nav-item">
                  <router-link to="/regionsview" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-mountain-city"></i>
                    <p>المناطق</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('cities_read')" class="nav-item">
                  <router-link to="/citiesview" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-city"></i>
                    <p>المدن</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('neighborhoods_read')" class="nav-item">
                  <router-link to="/neighborhoodview" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-tree-city"></i>
                    <p>الأحياء</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('ages_read')" class="nav-item">
                  <router-link to="/ages" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-calendar-days"></i>
                    <p>عُمر العقار</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('banks_read')" class="nav-item">
                  <router-link to="/banks" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-building-columns"></i>
                    <p>البنوك</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('complain_reasons_read')" class="nav-item">
                  <router-link to="/complainReasons" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-rectangle-list"></i>
                    <p>اسباب الشكاوى</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('admins_read')" class="nav-item">
                  <router-link to="/managerview" class="nav-link auto-close">
                    <i class="nav-icon bi bi-people"></i>
                    <p>مديرين الموقع</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('groups_read')" class="nav-item">
                  <router-link to="/groups" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-people-group"></i>
                    <p>المجموعات</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('settings_read')" class="nav-item">
                  <router-link to="/settings" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-gear"></i>
                    <p>الإعدادات</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('users_buffers_read')" class="nav-item">
                  <router-link to="/preRegister" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-hourglass-end"></i>
                    <p>تسجيل العملاء</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('admin_histories_read')" class="nav-item">
                  <router-link to="/histories" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-clock-rotate-left"></i>
                    <p>ارشيف الأحداث</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('error_logs_read')" class="nav-item">
                  <router-link to="/errorlogs" class="nav-link auto-close">
                    <i class="nav-icon bi bi-bug"></i>
                    <p>سجل الاخطاء</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('rega_notifications')" class="nav-item">
                  <router-link to="/rega" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-building-circle-exclamation"></i>
                    <p>تنبيهات الهيئة العامة للعقارات</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('settings_read')" class="nav-item">
                  <router-link to="/companyDetails" class="nav-link auto-close">
                    <i class="nav-icon fa-solid fa-building"></i>
                    <p>بيانات الشركة</p>
                  </router-link>
                </li>
                <li v-if="checkAccess('marketing_material_options_read')" class="nav-item">
                  <router-link to="/marketingMaterialOptions" class="nav-link auto-close">
                    <i class="nav-icon bi bi-list-check"></i>
                    <p>أنواع طلبات المواد التسويقية والتعميد</p>
                  </router-link>
                </li>
              </ul>
            </li>
            <!-- <li class="nav-header">DOCUMENTATIONS</li> -->
          </ul>
          <!--end::Sidebar Menu-->
        </nav>
      </div>   

      <!--end::Sidebar Wrapper-->
    </aside>
    <!--end::Sidebar-->
    <!--begin::App Main-->
    <router-view />
    <!--end::App Main-->
    <!--begin::Footer-->
    <footer class="app-footer">
      <!--begin::To the end-->
      <div class="float-end d-none d-sm-inline">للعقارات وإدارة الأملاك</div>
      <!--end::To the end-->
      <!--begin::Copyright-->
      <strong>
        حقوق النشر محفوظة لصالح شركة أحمد المحيسني العقارية
      </strong>
      <!--end::Copyright-->
    </footer>
    <!--end::Footer-->

    <!-- ============================================================ -->
    <!-- Modal: Update Profile (Name + Avatar)                        -->
    <!-- ============================================================ -->
    <div class="modal fade" id="profileModal" tabindex="-1" aria-labelledby="profileModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="profileModalLabel">
              <i class="bi bi-person-gear me-2"></i>تعديل الملف الشخصي
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="profileSuccess" class="alert alert-success">
              <i class="bi bi-check-circle me-1"></i> تم تحديث الملف الشخصي بنجاح
            </div>
            <div v-if="profileError" class="alert alert-danger">
              <i class="bi bi-exclamation-triangle me-1"></i> {{ profileMessage }}
            </div>
            <!-- Avatar preview -->
            <div class="text-center mb-3">
              <div class="position-relative d-inline-block">
                <img
                  v-if="avatarPreview || (GET_USER_DATA.avatar && !removeAvatar)"
                  :src="avatarPreview || ($store.getters.MEDIA_URL + GET_USER_DATA.avatar)"
                  class="rounded-circle border border-2 border-primary"
                  style="width:100px;height:100px;object-fit:cover;"
                  alt="Avatar"
                />
                <div
                  v-else
                  class="rounded-circle border border-2 border-secondary d-flex align-items-center justify-content-center bg-light"
                  style="width:100px;height:100px;"
                >
                  <i class="bi bi-person" style="font-size:48px;color:#999;"></i>
                </div>
                <label
                  for="avatarInput"
                  class="position-absolute bottom-0 end-0 btn btn-primary btn-sm rounded-circle p-1"
                  style="cursor:pointer;width:30px;height:30px;display:flex;align-items:center;justify-content:center;"
                  title="تغيير الصورة"
                >
                  <i class="bi bi-camera-fill" style="font-size:13px;"></i>
                </label>
                <input type="file" id="avatarInput" accept="image/*" class="d-none" @change="onAvatarChange" />
              </div>
              <div class="mt-2">
                <button
                  v-if="(GET_USER_DATA.avatar && !removeAvatar) || avatarPreview"
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  @click="clearAvatar"
                >
                  <i class="bi bi-trash me-1"></i> إزالة الصورة
                </button>
              </div>
            </div>
            <!-- Name -->
            <div class="mb-3">
              <label class="form-label fw-semibold">الاسم</label>
              <input type="text" class="form-control" v-model="profileName" placeholder="أدخل الاسم" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">إلغاء</button>
            <button type="button" class="btn btn-primary" @click="submitProfile" :disabled="profileLoading">
              <span v-if="profileLoading" class="spinner-border spinner-border-sm me-1"></span>
              <i v-else class="bi bi-save me-1"></i>
              حفظ التغييرات
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- Modal: Change Password                                        -->
    <!-- ============================================================ -->
    <div class="modal fade" id="passwordModal" tabindex="-1" aria-labelledby="passwordModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="passwordModalLabel">
              <i class="bi bi-key me-2"></i>تغيير كلمة المرور
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="passSuccess" class="alert alert-success">
              <i class="bi bi-check-circle me-1"></i> تم تغيير كلمة المرور بنجاح
            </div>
            <div v-if="passError" class="alert alert-danger">
              <i class="bi bi-exclamation-triangle me-1"></i> {{ passMessage }}
            </div>
            <div class="mb-3">
              <label for="current-password" class="form-label fw-semibold">كلمة المرور الحالية</label>
              <div class="input-group">
                <input id="current-password" :type="showOld ? 'text' : 'password'" class="form-control" v-model="oldPassword" :placeholder="showOld ? 'كلمة المرور الحالية' : '••••••••'" autocomplete="current-password" />
                <button class="btn btn-outline-secondary" type="button" :aria-label="showOld ? 'إخفاء كلمة المرور الحالية' : 'إظهار كلمة المرور الحالية'" :aria-pressed="showOld" @click="showOld = !showOld">
                  <i :class="showOld ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </button>
              </div>
            </div>
            <div class="mb-3">
              <label for="new-password" class="form-label fw-semibold">كلمة المرور الجديدة</label>
              <div class="input-group">
                <input id="new-password" :type="showNew ? 'text' : 'password'" class="form-control" v-model="newPassword" :placeholder="showNew ? 'كلمة المرور الجديدة' : '••••••••'" autocomplete="new-password" />
                <button class="btn btn-outline-secondary" type="button" :aria-label="showNew ? 'إخفاء كلمة المرور الجديدة' : 'إظهار كلمة المرور الجديدة'" :aria-pressed="showNew" @click="showNew = !showNew">
                  <i :class="showNew ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </button>
              </div>
              <div class="form-text">يجب أن لا تقل عن ٨ أحرف</div>
            </div>
            <div class="mb-3">
              <label for="confirm-password" class="form-label fw-semibold">تأكيد كلمة المرور الجديدة</label>
              <div class="input-group">
                <input id="confirm-password" :type="showConfirm ? 'text' : 'password'" class="form-control" :class="{ 'is-invalid': confirmMismatch }" v-model="confirmPassword" :placeholder="showConfirm ? 'تأكيد كلمة المرور الجديدة' : '••••••••'" autocomplete="new-password" />
                <button class="btn btn-outline-secondary" type="button" :aria-label="showConfirm ? 'إخفاء تأكيد كلمة المرور' : 'إظهار تأكيد كلمة المرور'" :aria-pressed="showConfirm" @click="showConfirm = !showConfirm">
                  <i :class="showConfirm ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                </button>
                <div class="invalid-feedback">كلمتا المرور غير متطابقتين</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">إلغاء</button>
            <button type="button" class="btn btn-danger" @click="submitPassword" :disabled="passLoading">
              <span v-if="passLoading" class="spinner-border spinner-border-sm me-1"></span>
              <i v-else class="bi bi-shield-lock me-1"></i>
              تغيير كلمة المرور
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, checkAccess } from '@/helpers/tools';
import { onMounted } from 'vue';


export default {
  name: 'Layout',
  data(){
    return {
      unseenNotifications: 0,
      // Profile modal
      profileName: '',
      avatarFile: null,
      avatarPreview: null,
      removeAvatar: false,
      profileLoading: false,
      profileSuccess: false,
      profileError: false,
      profileMessage: '',
      // Password modal
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      passLoading: false,
      passSuccess: false,
      passError: false,
      passMessage: '',
      showOld: false,
      showNew: false,
      showConfirm: false,
      isDarkMode: document.documentElement.getAttribute('data-bs-theme') === 'dark',
      _profileModal: null,
      _passwordModal: null,
    }
  },
  computed: {
    ...mapGetters(['GET_USER_DATA']),
    confirmMismatch() {
      return this.confirmPassword.length > 0 && this.confirmPassword !== this.newPassword;
    },
  },
  methods: {
    checkAccess,
    applyTheme(theme, persist = true) {
      this.isDarkMode = theme === 'dark';
      document.documentElement.setAttribute('data-bs-theme', theme);
      const themeMeta = document.querySelector('meta[name="theme-color"]');
      if (themeMeta) themeMeta.setAttribute('content', this.isDarkMode ? '#10140f' : '#f4f5f0');
      if (persist) localStorage.setItem('dashboard-theme', theme);
      window.dispatchEvent(new CustomEvent('dashboard-theme-change', { detail: { theme } }));
    },
    toggleTheme() {
      this.applyTheme(this.isDarkMode ? 'light' : 'dark');
    },
    menuScroll(){
      const SELECTOR_SIDEBAR_WRAPPER = '.sidebar-wrapper';
      const Default = {
        scrollbarTheme: 'os-theme-light',
        scrollbarAutoHide: 'leave',
        scrollbarClickScroll: true,
      };
      const sidebarWrapper = document.querySelector(SELECTOR_SIDEBAR_WRAPPER);
      if(!sidebarWrapper){
        setTimeout(() => this.menuScroll(), 200);
      }else{
        if (sidebarWrapper && typeof OverlayScrollbarsGlobal?.OverlayScrollbars !== 'undefined') {
          OverlayScrollbarsGlobal.OverlayScrollbars(sidebarWrapper, {
            scrollbars: {
              theme: Default.scrollbarTheme,
              autoHide: Default.scrollbarAutoHide,
              clickScroll: Default.scrollbarClickScroll,
            },
          });
        }
      }
    },
    logout(){
      this.$http.get('/api/admin/admins/logout').then(() => {
        this.$store.commit("REMOVE_USER_DATA");
        window.location.href = '/login';
      }).catch(err => {
        const msg = this.$globalError(err);
        toast(msg);
      });
    },
    notificationsCount(){
      this.$http.get('/api/admin/notifications/unseenCount').then(({data}) => {
        this.unseenNotifications = data.count;
      }).catch(() => {});
    },
    // ── Profile Modal ──────────────────────────────────────────────
    openProfileModal() {
      this.profileName = this.GET_USER_DATA.userName;
      this.avatarFile = null;
      this.avatarPreview = null;
      this.removeAvatar = false;
      this.profileSuccess = false;
      this.profileError = false;
      this.profileMessage = '';
      this._profileModal.show();
    },
    onAvatarChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.avatarFile = file;
      this.avatarPreview = URL.createObjectURL(file);
      this.removeAvatar = false;
    },
    clearAvatar() {
      this.avatarFile = null;
      this.avatarPreview = null;
      this.removeAvatar = true;
      // reset the file input so the same file can be re-selected if needed
      const input = document.getElementById('avatarInput');
      if (input) input.value = '';
    },
    submitProfile() {
      if (!this.profileName || this.profileName.trim().length < 2) {
        this.profileError = true;
        this.profileMessage = 'يجب إدخال الاسم بطريقة صحيحة (حرفان على الأقل)';
        return;
      }
      this.profileLoading = true;
      this.profileSuccess = false;
      this.profileError = false;
      const formData = new FormData();
      formData.append('name', this.profileName.trim());
      if (this.removeAvatar) {
        formData.append('removeAvatar', 'true');
      } else if (this.avatarFile) {
        formData.append('avatar', this.avatarFile);
      }
      this.$http.put('/api/admin/admins/updateProfile', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then(res => {
        this.profileLoading = false;
        this.profileSuccess = true;
        this.avatarFile = null;
        this.removeAvatar = false;
        this.$store.commit('SET_USER_DATA', {
          ...this.GET_USER_DATA,
          name: res.data.admin.name,
          avatar: res.data.admin.avatar,
          token: localStorage.getItem('userToken'),
          isSuperUser: this.GET_USER_DATA.isSuperUser,
          permissions: this.GET_USER_DATA.permissions,
          streamToken: this.GET_USER_DATA.streamToken,
          streamId: this.GET_USER_DATA.streamId,
        });
      }).catch(err => {
        this.profileLoading = false;
        this.profileError = true;
        this.profileMessage = this.$globalError(err);
      });
    },
    // ── Password Modal ─────────────────────────────────────────────
    openPasswordModal() {
      this.oldPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
      this.passSuccess = false;
      this.passError = false;
      this.passMessage = '';
      this.showOld = false;
      this.showNew = false;
      this.showConfirm = false;
      this._passwordModal.show();
    },
    submitPassword() {
      this.passError = false;
      this.passSuccess = false;
      if (!this.oldPassword) {
        this.passError = true;
        this.passMessage = 'يرجى إدخال كلمة المرور الحالية';
        return;
      }
      if (this.newPassword.length < 8) {
        this.passError = true;
        this.passMessage = 'كلمة المرور الجديدة يجب أن لا تقل عن ٨ أحرف';
        return;
      }
      if (this.newPassword !== this.confirmPassword) {
        this.passError = true;
        this.passMessage = 'كلمتا المرور غير متطابقتين';
        return;
      }
      this.passLoading = true;
      this.$http.put('/api/admin/admins/changePassword', {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
      }).then(res => {
        this.passLoading = false;
        this.passSuccess = true;
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
        this.showOld = false;
        this.showNew = false;
        this.showConfirm = false;
        if (res.data.token) localStorage.setItem('userToken', res.data.token);
      }).catch(err => {
        this.passLoading = false;
        this.passError = true;
        this.passMessage = this.$globalError(err);
      });
    },
  },
  mounted() {
    this.applyTheme(this.isDarkMode ? 'dark' : 'light', false);
    this._profileModal = new window.bootstrap.Modal(document.getElementById('profileModal'));
    this._passwordModal = new window.bootstrap.Modal(document.getElementById('passwordModal'));
  },
  created(){
    onMounted(() => {
      const script = document.createElement('script');
      script.src = '/assets/js/adminlte.js';
      script.async = true;
      document.body.appendChild(script);
      this.menuScroll();

      const currentWidth = window.innerWidth;
      if(currentWidth <= 991){
        document.querySelectorAll(".auto-close").forEach(button => {
          button.addEventListener("click", function() {
            document.body.classList.remove("sidebar-open");
            document.body.classList.add("sidebar-collapse");
          });
        });
      }
    });

    if(this.checkAccess('admin_notifications_read')){
      this.notificationsCount();
      setInterval(() => {
        this.notificationsCount();
      }, 300000);
    }
  },
}
</script>
